module.exports = __webpack_public_path__ + "img/face-fearful.f8294a5d.svg";